import { Api, generateSearchUrlParam, getGetParams } from "../../utils";
import urls from "../../config/urls";

export function fetchStewardBusinessPartnerListsApi(payload) {
  const urlParams = generateSearchUrlParam(payload, true);
  const url = `${urls.searchBP}?${urlParams}`;
  return Api.fetch(url, getGetParams());
}
